module.exports = __webpack_public_path__ + "media/operational-monitoring_en_ipad_old.0836e844.mp4";